(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  let header;
  let frame;
  const desktop = window.matchMedia('(min-width: 940px)');
  const sync = () => {
    frame = null;
    const current = document.querySelector('[data-section-type="header"]');
    if (current !== header) {
      stateObserver.disconnect();
      header = current;
      if (header) stateObserver.observe(header, { attributes: true, attributeFilter: ['class'] });
    }
    if (!header) return;
    const bell = document.querySelector('[data-kbd-discussion-bell].kbd-discussion-bell--header');
    const docked = desktop.matches && header.classList.contains('docked-header--dock');
    const cart = header.querySelector(docked ? '.docking-header__utils .header-cart' : '.utils__right .header-cart');
    if (bell && cart && (bell.parentElement !== cart.parentElement || bell.nextElementSibling !== cart)) {
      cart.before(bell);
    }
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(sync);
  };
  const stateObserver = new MutationObserver(schedule);
  const mountObserver = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 &&
      (node.matches('[data-kbd-discussion-bell], [data-section-type="header"]') ||
       node.querySelector('[data-kbd-discussion-bell], [data-section-type="header"]'))))) schedule();
  });
  mountObserver.observe(document.body, { childList: true, subtree: true });
  desktop.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kbd-home-commerce-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kbd-hub-scrolling-title')) {
    customElements.define('kbd-hub-scrolling-title', class extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        const update = () => {
          const text = this.firstElementChild;
          if (!text) return;
          const distance = Math.max(0, text.offsetWidth - this.clientWidth);
          this.style.setProperty('--title-travel', `-${distance}px`);
          this.style.setProperty('--title-duration', `${Math.max(6, distance / 22 + 4)}s`);
          this.toggleAttribute('data-overflow', this.clientWidth > 0 && distance > 1);
        };
        this.observer = new ResizeObserver(update);
        this.observer.observe(this);
        if (this.firstElementChild) this.observer.observe(this.firstElementChild);
        document.fonts.ready.then(() => { if (this.isConnected) update(); });
        update();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  if (!customElements.get('kbd-hub-carousel')) {
    customElements.define('kbd-hub-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const track = this.querySelector('.kbd-hub-carousel__track');
        const slides = Array.from(track.children);
        const dots = Array.from(this.querySelectorAll('[data-hub-dot]'));
        const previous = this.querySelector('[data-hub-prev]');
        const next = this.querySelector('[data-hub-next]');
        this.querySelector('.kbd-hub-carousel__controls').hidden = slides.length < 2;
        let active = 0;
        const position = slide => slide.getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
        const update = () => {
          active = slides.reduce((closest, slide, index) => Math.abs(position(slide) - track.scrollLeft) < Math.abs(position(slides[closest]) - track.scrollLeft) ? index : closest, 0);
          dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
          previous.disabled = active === 0;
          next.disabled = active === slides.length - 1;
        };
        const go = index => {
          const slide = slides[Math.max(0, Math.min(index, slides.length - 1))];
          if (slide) track.scrollTo({ left: position(slide), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        previous.addEventListener('click', () => go(active - 1), options);
        next.addEventListener('click', () => go(active + 1), options);
        dots.forEach((dot, index) => dot.addEventListener('click', () => go(index), options));
        track.addEventListener('scroll', update, { ...options, passive: true });
        track.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  if (!customElements.get('kbd-hub-tabs')) {
    customElements.define('kbd-hub-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        const panels = tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
        const activate = (index, focus = false) => {
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].hidden = i !== index;
          });
          if (focus) tabs[index].focus();
          const list = tabs[index].parentElement;
          const bounds = tabs[index].getBoundingClientRect();
          const listBounds = list.getBoundingClientRect();
          if (bounds.left < listBounds.left) list.scrollLeft += bounds.left - listBounds.left;
          if (bounds.right > listBounds.right) list.scrollLeft += bounds.right - listBounds.right;
        };
        tabs.forEach((tab, index) => {
          panels[index].setAttribute('role', 'tabpanel');
          panels[index].setAttribute('aria-labelledby', tab.id);
          panels[index].tabIndex = 0;
          tab.addEventListener('click', () => activate(index));
          tab.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            activate(event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length, true);
          });
        });
        this.closest('.kbd-commerce-hub').querySelectorAll('.kbd-hub-stats a').forEach(link => {
          const index = panels.findIndex(panel => '#' + panel.id === link.getAttribute('href'));
          if (index !== -1) link.addEventListener('click', () => activate(index));
        });
        const hashIndex = panels.findIndex(panel => '#' + panel.id === location.hash);
        activate(hashIndex >= 0 ? hashIndex : 0);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kbd-media-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kbd-media-library')) {
    customElements.define('kbd-media-library', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const filters = this.querySelector('.kbd-media-filters');
        if (filters) {
          const buttons = Array.from(filters.querySelectorAll('button'));
          const cards = Array.from(this.querySelectorAll('[data-media-category]'));
          filters.hidden = false;
          buttons.forEach(button => button.addEventListener('click', () => {
            const category = button.dataset.mediaFilter;
            buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            cards.forEach(card => { card.hidden = category !== 'all' && card.dataset.mediaCategory !== category; });
          }, { signal }));
        }
        this.dialog = this.querySelector('.kbd-media-video-dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.player = this.querySelector('[data-media-video-player]');
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-media-video]');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const videoId = link.dataset.mediaVideo;
          if (!/^[A-Za-z0-9_-]{11}$/.test(videoId)) return;
          event.preventDefault();
          this.openVideo(link, videoId);
        }, { signal });
        this.querySelector('[data-media-video-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('close', () => this.stopVideo(), { signal });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, { signal });
      }
      openVideo(link, videoId) {
        if (this.dialog.open) this.dialog.close();
        this.player.replaceChildren();
        this.trigger = link;
        const title = link.dataset.mediaTitle;
        const start = Math.max(0, Math.floor(Number(link.dataset.mediaStart) || 0));
        this.querySelector('[data-media-video-title]').textContent = title;
        this.dialog.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;
        const frame = document.createElement('iframe');
        frame.title = title;
        frame.width = '1280';
        frame.height = '720';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&playsinline=1&rel=0&start=${start}`;
        this.player.append(frame);
      }
      stopVideo() {
        this.player?.replaceChildren();
        if (this.scrollLocked) {
          if (document.documentElement.style.overflow === 'hidden') document.documentElement.style.overflow = this.previousOverflow;
          this.scrollLocked = false;
        }
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
        this.trigger = null;
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.stopVideo();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kbd-orbit-hero"] && !Shopify.designMode) return;
  try {
    
  function initializeKbdOrbit(section) {
    if (section.dataset.kbdOrbitInitialized === 'true') return;
    section.dataset.kbdOrbitInitialized = 'true';
    const canvas = section.querySelector('[data-kbd-orbit-stars]');
    const context = canvas.getContext('2d');
    const products = [...section.querySelectorAll('.kbd-orbit__product')];
    const pointer = { x: 0, y: 0 };
    let stars = [];
    let previousTime = 0;

    function resize() {
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(section.clientWidth * ratio);
      canvas.height = Math.round(section.clientHeight * ratio);
      context.setTransform(ratio, 0, 0, ratio, 0, 0);
      stars = Array.from({ length: Math.round(section.clientWidth / 3.2) }, () => {
        const depth = Math.random() ** 1.8;
        return { x: Math.random() * section.clientWidth, y: Math.random() * section.clientHeight, depth, size: .2 + depth * 1.45, alpha: .15 + depth * .72, speedX: 1.4 + depth * 7.5, speedY: .25 + depth * 1.8, phase: Math.random() * Math.PI * 2 };
      });
    }

    function draw(time) {
      if (!section.isConnected) return;
      const delta = Math.min((time - previousTime) / 1000 || 0, .05);
      previousTime = time;
      context.clearRect(0, 0, section.clientWidth, section.clientHeight);
      stars.forEach((star) => {
        star.x += star.speedX * delta;
        star.y += star.speedY * delta;
        if (star.x > section.clientWidth + 4) star.x = -4;
        if (star.y > section.clientHeight + 4) star.y = 0;
        const alpha = star.alpha * (.72 + Math.sin(time / 1200 + star.phase) * .28);
        context.fillStyle = `rgba(198,225,255,${alpha})`;
        context.beginPath();
        context.arc(star.x + pointer.x * star.depth * 16, star.y + pointer.y * star.depth * 12, star.size, 0, Math.PI * 2);
        context.fill();
      });
      requestAnimationFrame(draw);
    }

    section.addEventListener('pointermove', (event) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const bounds = section.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width - .5;
      const y = (event.clientY - bounds.top) / bounds.height - .5;
      pointer.x = x;
      pointer.y = y;
      products.forEach((product) => {
        const depth = Number(product.dataset.depth || .5);
        product.style.setProperty('--px', `${x * depth * 22}px`);
        product.style.setProperty('--py', `${y * depth * 16}px`);
      });
    });

    products.forEach((product) => {
      function visitProduct() {
        window.location.assign(product.dataset.productUrl);
      }

      product.addEventListener('click', visitProduct);
      product.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          visitProduct();
        }
      });
    });

    new ResizeObserver(resize).observe(section);
    resize();
    requestAnimationFrame(draw);
  }

  document.querySelectorAll('[data-kbd-orbit-hero]').forEach(initializeKbdOrbit);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-kbd-orbit-hero]');
    if (section) initializeKbdOrbit(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
